export const DISPLAY_TYPES = {
    INSCRIPT: 'INSCRIPT',
    SINGLE_SELECT: 'SINGLE_SELECT',
    STD_DROP: 'STD_DROP'
}